module.exports = __webpack_public_path__ + "asset/img/guohui.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guohui.png
// module id = kdAd
// module chunks = 1